import { BusinessResult, BusinessResultType, BusinessValidation, BusinessValidationType } from '../models/policy-business.model';

export function isValidEmail(email: string): BusinessResult {
  const validationInProgress: BusinessValidation = {
          businessValidationType: BusinessValidationType.none,
          errorMessage: '',
          hasError: false,
        };

  const result: BusinessResult = {
    resultType: BusinessResultType.ok,
    messages: [],
    data: null,
    validations: [validationInProgress],
  };
  if (!email || email.length === 0) {
    result.resultType = BusinessResultType.error;
    result.messages.push('shared.emailRequired');
  } else {
    const reg = /(\<|^)[\w\d._%+-]+@(?:[\w\d-]+\.)+(\w{2,})(\>|$)/i;
    const addresses = email.split(';');
    for (const address of addresses) {
      if (!reg.test(address.trim())) {
        result.resultType = BusinessResultType.error;
        result.messages.push('shared.emailNotValid');
        break;
      }
    }
  }
  return result;
}
